import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges,
  ViewEncapsulation,
} from "@angular/core";
import * as dayjs from "dayjs";
import { PharmaDataService } from "../pharma-data.service";
@Component({
  selector: "app-pharma-database-data-revisions-dropdown",
  templateUrl: "./pharma-database-data-revisions-dropdown.component.html",
  styleUrls: ["./pharma-database-data-revisions-dropdown.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class PharmaDatabaseDataRevisionsDropdownComponent implements OnInit {
  checkOptions = [
    { label: "Values", value: "values", checked: false },
    { label: "YoY%", value: "yoy", checked: false },
    { label: "% of Total", value: "percentage_total", checked: false },
  ];
  radioValue = "";
  inValidCustomDate = false;
  customDate = null;
  dvErrMsg = "";
  invalidDataview: boolean;
  selectedDataView: string;
  dataViewFilterVisible: boolean;
  dataviewApplied: boolean;
  popoverOpen = false;
  viewBy: string;
  @Input() singleSelect: boolean;
  @Input() dataView;
  @Input() noYoy?: boolean = false;
  @Input() showReset: boolean;
  @Input() showNIB: boolean;
  @Input() showNIBControl: boolean;
  @Input() consolidatedCount;

  @Output() saveDataView = new EventEmitter();
  @Output() showNIBChanged: EventEmitter<any> = new EventEmitter();

  constructor(private pharmaDataService: PharmaDataService) {
    this.dataView = {};
  }

  ngOnInit() {
    if (this.noYoy) {
      this.checkOptions = [
        { label: "Values", value: "values", checked: false },
        { label: "% of Total", value: "percentage_total", checked: false },
      ];
    } else {
      this.checkOptions = [
        { label: "Values", value: "values", checked: false },
        { label: "YoY%", value: "yoy", checked: false },
        { label: "% of Total", value: "percentage_total", checked: false },
      ];
    }
    this.pharmaDataService.dataRevisionPopupVisiblity.subscribe((value) => {
      this.dataViewFilterVisible = value;
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.dataView && changes.dataView.currentValue) {
      this.dataView = changes.dataView.currentValue;
      this.viewBy = this.dataView.view_by[0] || "";
      if (this.dataView && this.dataView["view_by"][0] !== "revision") {
        this.radioValue = "";
        for (let i = 0; i < this.checkOptions.length; i++) {
          this.checkOptions[i].checked = this.dataView["view_by"].includes(
            this.checkOptions[i].value,
          )
            ? true
            : false;
        }
        if (this.singleSelect) {
          this.selectedDataView =
            this.dataView["view_by"][0] === "values"
              ? "Values"
              : this.dataView["view_by"][0] === "percentage_total"
                ? "% of Total"
                : "YoY%";
        } else {
          this.selectedDataView = "Values,YoY%,% of Total";
        }
      } else if (this.dataView["revision"]) {
        if (this.dataView["revision"].startsWith("custom")) {
          this.radioValue = "custom";
          this.customDate = this.dataView["revision"].split("|")[1];
          this.selectedDataView = this.customDate;
        } else {
          this.radioValue = this.dataView["revision"];
          this.selectedDataView =
            this.dataView["revision"][0] === "1"
              ? `&Delta; ${this.dataView["revision"][0]} month`
              : `&Delta; ${this.dataView["revision"][0]} months`;
        }
      }
    }
  }

  radioValChange() {
    this.checkOptions.map((option) => {
      option.checked = false;
      return { ...option };
    });
    this.viewBy = "revision";
  }

  chkboxOptChange() {
    this.radioValue = "";
    if (this.singleSelect) {
      this.checkOptions.map((option) => {
        option.checked = option.value === this.viewBy;
        return { ...option };
      });
    }
  }

  onDateChange() {
    if (this.customDate !== null) {
      this.inValidCustomDate = false;
    }
  }

  applyDataView() {
    let viewBy = [];
    if (
      !this.radioValue &&
      !this.showNIB &&
      !this.checkOptions[0].checked &&
      this.checkOptions[1] &&
      !this.checkOptions[1].checked &&
      this.checkOptions[2] &&
      !this.checkOptions[2].checked
    ) {
      this.invalidDataview = true;
      // this.dv  = "Please select a value";
    } else {
      this.invalidDataview = false;
      this.dvErrMsg = "";
      if (this.radioValue !== "") {
        let revision = "";
        let dateStr = "";
        viewBy = ["revision"];
        switch (this.radioValue) {
          case "1m":
            this.inValidCustomDate = false;
            this.selectedDataView = "&Delta; 1 month";
            dateStr = dayjs().subtract(30, "day").format("MM-DD-YYYY");
            revision = `1m`;
            break;
          case "3m":
            this.inValidCustomDate = false;
            this.selectedDataView = "&Delta; 3 months";
            dateStr = dayjs().subtract(90, "day").format("MM-DD-YYYY");
            revision = `3m`;
            break;
          case "custom":
            if (this.customDate === null) this.inValidCustomDate = true;
            else {
              this.inValidCustomDate = false;
              dateStr = dayjs(this.customDate).format("MM-DD-YYYY");
              this.selectedDataView = dateStr;
              revision = `custom|${dateStr}`;
            }
            break;
          default:
            break;
        }
        this.setDataView(revision, viewBy);
      } else {
        this.inValidCustomDate = false;
        if (this.singleSelect) {
          this.checkOptions.forEach((val) => {
            if (val.checked) {
              this.selectedDataView = val.label;
              return;
            }
          });
          this.setDataView("", [
            this.selectedDataView === "Values"
              ? "values"
              : this.selectedDataView === "% of Total"
                ? "percentage_total"
                : "yoy",
          ]);
        } else {
          if (this.checkOptions[0].checked && this.checkOptions[1].checked) {
            this.selectedDataView = "Values,YoY%";
            this.setDataView("", ["values", "yoy"]);
          } else {
            if (this.checkOptions[0].checked) {
              this.selectedDataView = this.checkOptions[0].label;
              this.setDataView("", ["values"]);
            }
            if (this.checkOptions[1].checked) {
              this.selectedDataView = this.checkOptions[1].label;
              this.setDataView("", ["yoy"]);
            }
            if (this.checkOptions[2].checked) {
              this.selectedDataView = this.checkOptions[2].label;
              this.setDataView("", ["percentage_total"]);
            }
          }
        }
      }
    }
    this.showNIBChanged.emit(this.showNIB);
    //this.inValidCustomDate
  }

  setDataView(revision, viewBy) {
    if (!this.inValidCustomDate) {
      this.dataViewFilterVisible = false;
      this.dataviewApplied = true;
      this.saveDataView.emit({ viewBy, revision });
    }
  }

  disabledCustomDate = (customValue: Date): boolean => {
    return customValue >= dayjs().toDate();
  };

  popoverChange() {
    this.popoverOpen = !this.popoverOpen;
    if (this.popoverOpen) {
      this.dataviewApplied = false;
    }
    if (!this.popoverOpen && !this.dataviewApplied) {
      this.onResetDataView();
    }
  }

  onResetDataView() {
    this.dataViewFilterVisible = false;
    this.showNIB = false;
    this.showNIBChanged.emit(this.showNIB);
    if (this.dataView && this.dataView["view_by"][0] !== "revision") {
      this.radioValue = "";
      for (let i = 0; i < this.checkOptions.length; i++) {
        this.checkOptions[i].checked = this.dataView["view_by"].includes(
          this.checkOptions[i].value,
        )
          ? true
          : false;
      }
      if (this.dataView["view_by"].length < 3) {
        this.selectedDataView =
          this.dataView["view_by"][0] === "values"
            ? "Values"
            : this.dataView["view_by"][0] === "percentage_total"
              ? "% of Total"
              : "YoY%";
      } else {
        this.selectedDataView = "Values,YoY%,% of Total";
      }
    } else {
      for (let i = 0; i < this.checkOptions.length; i++) {
        this.checkOptions[i].checked = false;
      }
      if (this.dataView["revision"].startsWith("custom")) {
        this.radioValue = "custom";
        this.customDate = this.dataView["revision"].split("|")[1];
      } else {
        this.radioValue = this.dataView["revision"];
      }
    }
    this.viewBy = this.dataView.view_by[0] || "";
    this.saveDataView.emit({
      viewBy: [this.viewBy],
      revision: this.dataView["revision"] ? this.dataView["revision"] : "",
    });
  }

  showNIBChange() {
    this.showNIBChanged.emit(this.showNIB);
    this.pharmaDataService.logUserAction(
      this.showNIB
        ? "SHOW_NIB_CHECKBOX_SELECTED"
        : "SHOW_NIB_CHECKBOX_UNSELECTED",
      {},
    );
  }
}
